import React, { useEffect, useRef, useState } from "react";
import QRDialog from "../../organisms/QRDialog";
import { ReactComponent as Icons } from "../../symbol-defs.svg";
import classNames from "classnames";
import "./_StudioEntry.scss";
import clickIcon from "../../SVG/svg/click.svg";
import {
  entryViews,
  mainUiActions,
  useUiDispatch,
  useUiState
} from "../../../reducers/mainui.reducer";
import {
  designListActions,
  useDesignListState,
  useDispatchDesignList
} from "../../../reducers/designlist.reducer";
import {
  useDispatchVisualization,
  useVisualizationState,
  visualizationsActions,
  visViewModes
} from "../../../reducers/visualizations.reducer";
import {
  designDetailActions,
  useDesignDetailState,
  useDispatchDesignDetail
} from "../../../reducers/designdetails.reducer";
import { getCustomClass, handleNavigation } from "../../../utils/domUtils";
import { useInitDesignMount } from "../../../hooks/initDesignListHook";
import { AtSpinnerOverlay } from "../../atoms/AtSpinner";
import AtIcon from "../../atoms/AtIcon";
import AppProvider from "../../../api/appProvider";
import { useSwipeable } from "react-swipeable";
import Stage from "../../organisms/StageNew";
import CopyrightSection from "../../molecules/CopyrightSection";
import RoomList from "../../organisms/RoomList";
import { doesStringMatch } from "../../../utils/utils";
import { trimString } from "../../../utils/treeutils";
import AtIconUp from "../../SVG/AtIconUp";
import AtIconDown from "../../SVG/AtIconDown";
import AtIconPlay from "../../SVG/AtIconPlay";
import AtIconPause from "../../SVG/AtIconPause";
var scrollBarsToggle = {
  illustrations: false
};
var roomContainerClassName = ".at-vis-thumbs";
const StudioEntry = () => {
  const dispatchDesignList = useDispatchDesignList();
  const visualizationState = useVisualizationState();
  const visualizationDispatch = useDispatchVisualization();
  const designDetailsState = useDesignDetailState();
  const dispatchDesignState = useDispatchDesignDetail();
  const { designDetails } = designDetailsState;
  const uiState = useUiState();
  const dispatchUiState = useUiDispatch();
  const state = useDesignListState();
  const refCreateYourRug = useRef(null);
  const refRoomViewContainer = useRef(null);
  const [currentDetailView, setCurrentDetailView] = useState(
    sessionStorage.getItem("defaultDesignView") || window.flags.createYourRug.defaultDesignView //url link priority first,then flags
  );
  const [detailViewsOptions, setDetailViewsOptions] = useState(
    window.flags.createYourRug.detailViewsOptions
  );
  const [similarDesigns, setSimilarDesigns] = useState({ files: [], children: [] });
  const [hasInitialScrollDiv, setHasInitialScrollDiv] = useState(true);

  useInitDesignMount();

  const [loadingDesign, setLoadingDesign] = useState(true);
  const [showScrollBars, setShowScrollBars] = useState(scrollBarsToggle);
  const [removeArrowNoVariation, setRemoveArrowNoVariation] = useState(false);
  const [removeArrowRoomNoVariation, setRemoveArrowRoomNoVariation] = useState(false);
  const [isNextDesignClicked, setIsNextDesignClicked] = useState(true);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSwipeInProgress, setIsSwipeInProgress] = useState(false);
  useEffect(() => {
    const hasModalShown = localStorage.getItem("modalShown");
    setTimeout(() => {
      if (!hasModalShown) {
        setShowModal(true);
        localStorage.setItem("modalShown", "true");
      }
    }, [2000]);
  }, []);

  useEffect(() => {
    if (designDetailsState.loading) return;
    setLoadingDesign(false);
    dispatchUiState({
      type: mainUiActions.SET_SHOW_LOAD_OVERLAY,
      payload: false
    });
  }, [designDetailsState.loading]);
  const [currentImagePosition, setCurrentImagePosition] = useState(1);
  const [image1, setImage1] = useState();
  const [image2, setImage2] = useState();

  useEffect(() => {
    if (state.selectedFile.fullPath == undefined) return;
    async function get1xDesign() {
      await AppProvider.get1xDesign({
        file: state.activeVariation.fullPath
          ? state.activeVariation.fullPath
          : state.selectedFile.fullPath
      }).then(getDesign => {
        fetch(getDesign).then(() => {
          if (currentImagePosition == 1) {
            document.getElementById("currentImage2").style.removeProperty("animation");
            setCurrentImagePosition(2);
            if (!image2) {
              document.getElementById("currentImage2").src = getDesign;
            } else {
              setImage2(image2);
            }
            setImage1(getDesign);
            document.getElementById("currentImage1").src = getDesign;
            setTimeout(() => {
              document.getElementById("currentImage1").style.animation = "fadeIn 3s";
              document.getElementById("currentImage1").style.zIndex = 2;
              document.getElementById("currentImage2").style.zIndex = 1;
            }, 1000);
          } else {
            document.getElementById("currentImage1").style.removeProperty("animation");
            setCurrentImagePosition(1);
            setImage1(image1);
            setImage2(getDesign);
            document.getElementById("currentImage1").src = image1;
            document.getElementById("currentImage2").src = getDesign;
            setTimeout(() => {
              document.getElementById("currentImage2").style.animation = "fadeIn 3s";
              document.getElementById("currentImage1").style.zIndex = 1;
              document.getElementById("currentImage2").style.zIndex = 2;
            }, 1000);
          }
        });
      });
    }
    get1xDesign();
    async function getSimilarDesigns() {
      if (isNextDesignClicked) {
        if (state.similarDesignsFolder.files.length != 0) {
          setRemoveArrowNoVariation(false);
          let resVar = state.similarDesignsFolder.files;
          setSimilarDesigns({
            ...similarDesigns,
            files: resVar.map(item => ({ ...item, name: null }))
          });

          if (resVar.find(item => !item.thumbUrl))
            resVar = await AppProvider.getDesignThumbnails({
              designs: state.similarDesignsFolder.files
            });

          setSimilarDesigns({ ...similarDesigns, files: resVar });
        } else {
          setRemoveArrowNoVariation(true);
        }
      }
    }
    getSimilarDesigns();
  }, [state.selectedFile, state.similarDesignsFolder, state.activeVariation]);
  const scrollIntoView = querySelector => {
    if (querySelector) {
      const elem = document.querySelector(querySelector);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      } else {
        console.log(querySelector, " not found");
      }
    }
  };

  const handleDoubleClick = async () => {
    var fileName = "";
    var fileVarName = "";

    if (state.selectedFile.fullPath.includes("/")) {
      const designName = state.selectedFile.fullPath.split("/").pop();
      var folder =
        state.selectedFile.location.includes("/") && state.selectedFile.location.split("/");
      if (folder.length > 2) {
        folder = folder.slice(1).join("/");
      } else {
        folder = folder.pop();
      }

      if (state.activeVariation) {
        fileVarName = state.activeVariation.name;

        fileName = folder ? folder + "/" + designName.split(".")[0] : designName.split(".")[0];
      } else {
        fileName = folder ? folder + "/" + designName.split(".")[0] : designName.split(".")[0];

        fileVarName = "";
      }
    }

    let getPageName = sessionStorage.getItem("page");

    window.flags.entryTemplate === entryViews.STUDIO
      ? window.open(
          `https://myroom.studio/studio?rug=${fileName}&variation=${fileVarName}`,
          "_blank"
        )
      : window.open(
          `${AppProvider.domain}/explorug.html?page=${getPageName}&initdesign=${fileName}&initvar=${fileVarName}`,
          "_blank"
        );
  };

  const handleNavigator = ({ querySelector, direction }) => {
    if (!querySelector || !direction) return;
    const elem = document.querySelector(querySelector);
    handleNavigation({ elem, direction });
  };

  const changeViewIndex = (direction, currentDetailView, viewsOptions) => {
    let newcurrentDetailView =
      direction === "right" ? currentDetailView + 1 : currentDetailView - 1;

    newcurrentDetailView =
      newcurrentDetailView > viewsOptions.length - 1 ? 0 : newcurrentDetailView;
    newcurrentDetailView =
      newcurrentDetailView < 0 ? viewsOptions.length - 1 : newcurrentDetailView;

    return newcurrentDetailView;
  };

  function getAllFiles(node) {
    let files = [];

    if (node.files && Array.isArray(node.files)) {
      files = node.files.filter(file => {
        const name = file.location.split("/").pop(); // get the last part
        return !name.startsWith(".");
      });
    }

    if (node.children && Array.isArray(node.children)) {
      for (const child of node.children) {
        files = files.concat(getAllFiles(child));
      }
    }

    return files;
  }
  const openNextDetailView = async ({ direction = "right" }) => {
    setIsNextDesignClicked(true);
    setLoadingDesign(true);

    let newDesign = [];
    let currentFolder = [state.tree[0]];
    const items = currentFolder
      .filter(node => node.children.length || node.files.length)
      .map((item, index) => {
        const filteredChildren = item.children.filter(child => child.name.charAt(0) != ".");
        const filteredFiles = item.files.filter(file => file.name.charAt(0) != ".");

        return {
          ...item,
          children: filteredChildren,
          files: filteredFiles
        };
      });

    const files = getAllFiles(items[0]);

    // Find the current file index
    let currentDesignIndex = files.findIndex(obj => obj.id === state.selectedFile.id);

    let newDesignViewIndex = changeViewIndex(direction, currentDesignIndex, files);

    newDesign = files[newDesignViewIndex];

    await AppProvider.getDesignThumbnails({
      designs: [{ fullPath: newDesign.fullPath }]
    }).then(newDesignDetails => {
      const mergedDesignDetails = {
        ...newDesign,
        ...newDesignDetails[0]
      };

      dispatchDesignList({
        type: designListActions.SELECT_DESIGN,
        payload: {
          selectedFile: mergedDesignDetails,
          activeVariation: {}
        }
      });
    });
  };

  const combinedData = [...similarDesigns.files, state.selectedFile];
  const showNextVariation = async ({ direction = "right" }) => {
    setLoadingDesign(true);
    setIsNextDesignClicked(false);
    var currentDesignIndex = combinedData.findIndex(obj => obj.id === state.activeVariation.id);
    if (currentDesignIndex == -1) {
      currentDesignIndex = 3;
    }

    var newDesignViewIndex = changeViewIndex(direction, currentDesignIndex, combinedData);
    dispatchDesignList({
      type: designListActions.SET_ACTIVE_VARIATION,
      payload: combinedData[newDesignViewIndex]
    });
    let name = combinedData[newDesignViewIndex].name;

    if (!doesStringMatch(name, state.selectedFile.name)) {
      name = `${state.selectedFile.name} ${trimString(name)}`;
    }

    const { name: originalName } = state.selectedFile;

    dispatchDesignState({
      type: designDetailActions.SET_DETAILS,
      payload: {
        designDetails: combinedData[newDesignViewIndex].designProps,
        label: name,
        fullpath: combinedData[newDesignViewIndex].fullPath,
        originalName,
        setCustomConversion: window.flags.ordersheet.customConversion.setCustomConversion || false,
        customInToCmFactor: window.flags.ordersheet.customConversion.customInToCmFactor
      }
    });
  };
  const showNextRoom = async ({ direction }) => {
    const tempGetMainRoomFolder = visualizationState.activeNode.FullPath.split("/");
    tempGetMainRoomFolder.pop();

    const getMainRoomFolder = tempGetMainRoomFolder.join("/");

    if (visualizationState.roomFolders.length) {
      const currentRoomIndex = visualizationState.roomFolders.findIndex(
        obj => obj.FullPath == getMainRoomFolder
      );

      var newRoomViewIndex = changeViewIndex(
        direction,
        currentRoomIndex,
        visualizationState.roomFolders
      );
      const newRoom = visualizationState.illustrations.find(
        obj => obj.FullPath == visualizationState.roomFolders[newRoomViewIndex].files[0]
      );

      const roomWithThumbs = await AppProvider.getRoomThumbnails({ rooms: [newRoom] });

      visualizationDispatch({
        type: visualizationsActions.SET_ACTIVE_NODE,
        payload: roomWithThumbs[0]
      });
      visualizationDispatch({
        type: visualizationsActions.SET_SIMILAR_ROOMS,
        payload: visualizationState.roomFolders[newRoomViewIndex].files
      });
      if (visualizationState.roomFolders[newRoomViewIndex].files.length == 1) {
        setRemoveArrowRoomNoVariation(true);
      } else {
        setRemoveArrowRoomNoVariation(false);
      }
    } else {
      const currentRoomIndex = visualizationState.illustrations.findIndex(
        obj => obj.FullPath == visualizationState.activeNode.FullPath
      );
      var newRoomViewIndex = changeViewIndex(
        direction,
        currentRoomIndex,
        visualizationState.illustrations
      );

      const roomWithThumbs = await AppProvider.getRoomThumbnails({
        rooms: [visualizationState.illustrations[newRoomViewIndex]]
      });
      visualizationDispatch({
        type: visualizationsActions.SET_ACTIVE_NODE,
        payload: roomWithThumbs[0]
      });

      setRemoveArrowRoomNoVariation(false);
    }
  };
  const showSameRoomVariation = async ({ direction }) => {
    const currentRoomIndex = visualizationState.similarRooms.findIndex(
      obj => obj == visualizationState.activeNode.FullPath
    );
    var newRoomViewIndex = changeViewIndex(
      direction,
      currentRoomIndex,
      visualizationState.similarRooms
    );
    const newRoom = visualizationState.illustrations.find(
      obj => obj.FullPath == visualizationState.similarRooms[newRoomViewIndex]
    );
    const roomWithThumbs = await AppProvider.getRoomThumbnails({ rooms: [newRoom] });
    visualizationDispatch({
      type: visualizationsActions.SET_ACTIVE_NODE,
      payload: roomWithThumbs[0]
    });
  };

  useEffect(() => {
    document.getElementsByTagName("body")[0].id = "studioentry";
    dispatchUiState({ type: mainUiActions.SET_LOADING_OVERLAY_PERCENT, payload: 30 });
    if (window.TextureOptions?.AdditionalTextureNames?.indexOf("Back") !== -1) {
      setDetailViewsOptions([
        visViewModes.DESIGN_VIEW_DEEPZOOM,
        visViewModes.DESIGN_VIEW_PERSPECTIVE,
        visViewModes.DESIGN_VIEW_FOLDEDBACK
      ]);
    }

    let scrollTo = sessionStorage.getItem("scrollTo") || "";
    if (scrollTo) setHasInitialScrollDiv(true);
    setTimeout(() => {
      let illustrations = scrollBarsToggle.illustrations;
      const elem = document.querySelector(roomContainerClassName);
      if (elem && elem.clientWidth < elem.scrollWidth) {
        illustrations = true;
      }
      setShowScrollBars({ ...showScrollBars, illustrations });
      const elemVariations = document.querySelector("#atDesignVariations");
      //   elemVariations ? setHasVariations(true) : setHasVariations(false);
      if (scrollTo !== "") {
        scrollIntoView("#" + scrollTo);
      }
      setHasInitialScrollDiv(false);
    }, 3000);
    setTimeout(() => {
      dispatchUiState({ type: mainUiActions.SET_LOADING_OVERLAY_PERCENT, payload: 60 });
    }, 1500);
  }, []);

  useEffect(() => {
    if (!designDetails) return;
    const isIrregular = designDetails.IsIrregular;
    if (
      isIrregular &&
      detailViewsOptions[currentDetailView] === visViewModes.DESIGN_VIEW_FOLDEDBACK
    ) {
      dispatchUiState({
        type: mainUiActions.SET_TOAST_PROPS,
        payload: {
          message: "Sorry, folded view is unavailable for this design.",
          intent: "warning"
        }
      });
      setCurrentDetailView(0);
    }
  }, [designDetails]);
  const changeRoomHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (!isSwipeInProgress && !designDetailsState.loading && !isFullScreen) {
        setIsSwipeInProgress(true);
        showNextRoom({ direction: "right" }); // Reset the flag after 2 seconds (or your desired duration)
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedRight: () => {
      if (!isSwipeInProgress && !designDetailsState.loading && !isFullScreen) {
        setIsSwipeInProgress(true);
        showNextRoom({ direction: "left" }); // Reset the flag after 2 seconds (or your desired duration)
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedUp: () => {
      if (
        !isSwipeInProgress &&
        !designDetailsState.loading &&
        removeArrowRoomNoVariation &&
        !isFullScreen
      ) {
        setIsSwipeInProgress(true);
        showSameRoomVariation({ direction: "left" }); // Reset the flag after 2 seconds (or your desired duration)
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedDown: () => {
      if (
        !isSwipeInProgress &&
        !designDetailsState.loading &&
        removeArrowRoomNoVariation &&
        !isFullScreen
      ) {
        setIsSwipeInProgress(true);
        showSameRoomVariation({ direction: "right" }); // Reset the flag after 2 seconds (or your desired duration)
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    swipeDuration: 2000,
    preventScrollOnSwipe: true,
    trackMouse: true
  });
  const changeDesignHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (!isSwipeInProgress && !designDetailsState.loading) {
        setIsSwipeInProgress(true);
        openNextDetailView({ direction: "right" }); // Reset the flag after 2 seconds (or your desired duration)
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedRight: () => {
      if (!isSwipeInProgress && !designDetailsState.loading) {
        setIsSwipeInProgress(true);
        openNextDetailView({ direction: "left" }); // Reset the flag after 2 seconds (or your desired duration)
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedUp: () => {
      if (!isSwipeInProgress && !designDetailsState.loading && !removeArrowNoVariation) {
        setIsSwipeInProgress(true);
        showNextVariation({ direction: "left" }); // Reset the flag after 2 seconds (or your desired duration)
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    onSwipedDown: () => {
      if (!isSwipeInProgress && !designDetailsState.loading && !removeArrowNoVariation) {
        setIsSwipeInProgress(true);
        showNextVariation({ direction: "right" }); // Reset the flag after 2 seconds (or your desired duration)
        setTimeout(() => {
          setIsSwipeInProgress(false);
        }, [1500]);
      }
    },
    swipeDuration: 2000,
    preventScrollOnSwipe: true,
    trackMouse: true
  });
  return (
    <>
      <Icons />
      <QRDialog />
      {showModal && (
        <div className="modal-content">
          <span className="close" onClick={() => setShowModal(false)}>
            &times;
          </span>
          <h1>DIRECTIONS</h1>
          <table className="infoDiv">
            <tr className="infoText">
              <td>
                <AtIconUp width="45" height="25" />
                <AtIconDown width="45" height="25" />
              </td>
              <td>
                <p>Swipe or Click for design and room variations.</p>
              </td>
            </tr>
            <tr className="infoText">
              <td>
                <AtIconUp width="45" height="25" className="leftRightArrow" />
                <AtIconDown width="45" height="25" className="leftRightArrow" />
              </td>
              <td>
                <p>Swipe or Click to change designs and rooms.</p>
              </td>
            </tr>
            <tr className="infoText">
              <td>
                <div style={{ display: "flex" }}>
                  <button className="iconBox1">
                    <AtIconPlay />
                  </button>
                  <button className="iconBox1">
                    <AtIconPause />
                  </button>
                </div>
              </td>
              <td>
                <p>Single Click or Tap to pause and play.</p>
              </td>
            </tr>
            <tr className="infoText">
              <td>
                <img src={clickIcon} />
              </td>
              <td>
                <p>Double Click on the scene to customize.</p>
              </td>
            </tr>
          </table>
        </div>
      )}
      {uiState.showLoadingOverlay && !window.InterfaceElements.IsAdmin && (
        <div id="loadingDiv">
          <img
            id="loadingIcon"
            src="https://myroom.studio/images/site/loading.webp"
            loading="lazy"
            alt="wool_loading"
          />
        </div>
      )}

      <div
        ref={refCreateYourRug}
        id="app-main-studioEntry"
        className={classNames("app-main multiple-mode", getCustomClass())}
      >
        <div {...changeDesignHandlers}>
          <div className="cyr-section cyr-detailView">
            <div
              className="stage-wrapper deepzoom "
              onDoubleClick={handleDoubleClick}
              style={{ cursor: "pointer" }}
            >
              <img src="" alt="" className="rendered1xDesign1" id="currentImage1" />
              <img src="" alt="" className="rendered1xDesign1" id="currentImage2" />

              {!window.initialData.hideLoadingOverlay ? (
                <AtSpinnerOverlay show={loadingDesign} />
              ) : null}

              {!designDetailsState.loading && (
                <div className="cyr-arrows-container">
                  <AtIcon
                    className="navigator-arrows right"
                    icon="chevron-right"
                    onClick={() => openNextDetailView({ direction: "right" })}
                    color="#F05223"
                  />
                  <AtIcon
                    className="navigator-arrows left"
                    icon="chevron-left"
                    onClick={() => openNextDetailView({ direction: "left" })}
                    color="#F05223"
                  />
                  {!removeArrowNoVariation && (
                    <>
                      <AtIcon
                        className="navigator-arrows up"
                        icon="chevron-up"
                        onClick={() => showNextVariation({ direction: "right" })}
                        color="#F05223"
                      />
                      <AtIcon
                        className="navigator-arrows down"
                        icon="chevron-down"
                        onClick={() => showNextVariation({ direction: "left" })}
                        color="#F05223"
                      />
                    </>
                  )}
                </div>
              )}
              <div className="cyr-overlay left"></div>
              <div className="cyr-overlay right"></div>
            </div>
          </div>
        </div>
        <div {...changeRoomHandlers}>
          <div className="cyr-roomViewContainer" ref={refRoomViewContainer}>
            <div
              className="stage-wrapper deepzoom"
              id="room-view-container-studioEntry"
              style={{ cursor: "pointer" }}
            >
              <Stage
                defaultViewMode={
                  visualizationState.viewMode === visViewModes.MY_ROOM
                    ? visViewModes.MY_ROOM
                    : visViewModes.ROOM_VIEW
                }
                setIsFullScreen={setIsFullScreen}
                showModal={showModal}
                setShowModal={setShowModal}
              />
              {!designDetailsState.loading && (
                <div className="cyr-arrows-container">
                  <AtIcon
                    className="navigator-arrows right rightRoom"
                    icon="chevron-right"
                    onClick={() => showNextRoom({ direction: "right" })}
                    color="#F05223"
                  />
                  <AtIcon
                    className="navigator-arrows left leftRoom"
                    icon="chevron-left"
                    onClick={() => showNextRoom({ direction: "left" })}
                    color="#F05223"
                  />
                  {removeArrowRoomNoVariation ||
                    (visualizationState.similarRooms.length && (
                      <>
                        <AtIcon
                          className="navigator-arrows up topRoom"
                          icon="chevron-up"
                          onClick={() => showSameRoomVariation({ direction: "right" })}
                          color="#F05223"
                        />
                        <AtIcon
                          className="navigator-arrows down downRoom"
                          icon="chevron-down"
                          onClick={() => showSameRoomVariation({ direction: "left" })}
                          color="#F05223"
                        />
                      </>
                    ))}
                </div>
              )}
            </div>

            {/* <SidebarActionButtons
                isFullScreen={isRoomviewInFullScreen}
                handleFullScreen={handleFullScreen}
                handleCinematic={handleCinematic}
              /> */}
          </div>
        </div>
        <div className="cyr-section cyr-copyright">
          <CopyrightSection />
        </div>
        <div className="illustration-wrapper">
          <RoomList scrollIntoView={scrollIntoView} />

          {showScrollBars && showScrollBars.illustrations && (
            <div className="cyr-arrows-container">
              <AtIcon
                className="navigator-arrows right"
                icon="chevron-right"
                onClick={() =>
                  handleNavigator({ querySelector: roomContainerClassName, direction: "right" })
                }
              />
              <AtIcon
                className="navigator-arrows"
                icon="chevron-left"
                onClick={() =>
                  handleNavigator({ querySelector: roomContainerClassName, direction: "left" })
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

StudioEntry.propTypes = {};

export default StudioEntry;
